import React from 'react';
import { Outlet } from 'react-router-dom';

import CoursePauseTypeSelect from './CoursePauseTypeSelect';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import FilterDrawer from './FilterDrawer';
import NavBar from 'components/NavBar';

function CoursePausePage() {
  return (
    <>
      <NavBar
        title="COURSE RESUME TOOL"
        id="course-resume"
      >
        <CoursePauseTypeSelect />
      </NavBar>
      <ElementSpacePlaceholder elementId="course-resume" />
      <FilterDrawer />
      <Outlet />
    </>
  );
}

export default CoursePausePage;
